const phoneCapture: RegExp = /(\d)+/g;

export function isValid (phone: string): boolean {
    const digits = parse(phone);
    return digits.length >= 10 && digits.length <= 11;
}

export function parse (phone: string): string {
    let digits = "";

    if (!phone) {
      return digits;
    }

    for (let match = phoneCapture.exec(phone); match; match = phoneCapture.exec(phone)) {
      digits += match[0];
    }

    return digits;
  }